import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [error, setError] = useState(null);
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      loginWithGoogle(sessionId)
        .then(() => navigate('/'))
        .catch(() => {
          setError(isRTL ? 'فشل تسجيل الدخول' : 'Login failed');
          setTimeout(() => navigate('/login'), 2000);
        });
    } else {
      navigate('/login');
    }
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2" style={{ borderColor: 'var(--theme-accent, #D4AF37)' }} />
    </div>
  );
};
